import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "jwQuestionStuNaire/";

// 教学质量评价 - 列表
export const teachEvaluatePage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "list", {
           data: _params,
           method: "GET",
         });
       };

// 教学质量评价 - 列表
export const getWaitList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "getWaitList", {
    data: _params,
    method: "GET",
  });
};
// 教学质量评价 - 获取学生网络课程教评列表
export const teachEvaluateGetNetList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getNetList", {
           data: _params,
           method: "GET",
         });
       };

// 教学质量评价 - 学生提交问卷
export const teachEvaluateBankIds = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "bankIds", {
    data: _params,
    method: "POST",
  });
};
// 教学质量评价 - 学生提交问卷(网络课程)
export const teachEvaluateNetSubmit = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "netSubmit", {
    data: _params,
    method: "POST",
  });
};

// 教学质量评价 - 详情
export const teachEvaluateView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};

// 教学质量评价 - 是否强制学生评论问卷
export const mandatoryQuestionnaire = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "mandatoryQuestionnaire", {
    data: _params,
    method: "GET",
  });
};

// 教学质量评价 - 根据观看视频课程，判断是否需要评价问卷（所有课程章节观看完成，才强制评价）:viewingResults:0代表不需要强制评价问卷，1代表强制
export const getViewingResults = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "getViewingResults", {
    data: _params,
    method: "GET",
  });
};

// 教学质量评价 - 根据观看视频课程，判断是否需要评价问卷（所有课程章节观看完成，才强制评价）:viewingResults:0代表不需要强制评价问卷，1代表强制
export const getViewingContactResults = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "getViewingContactResults", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/teachEvaluate.js